export const environment = {
  production: true,
  SWCacheEnabled: true, //use the builtin service worker cache
  apiEndpoint: "https://mit-api-test1-dr.azure.chevron.com/api/",
  vintageFrameEndpoint: "https://inspections-test1-dr.chevron.com",

  msalConfig: {
    clientId: 'e8247028-20da-4031-b897-b98a3519cc37',
    authority: 'https://login.microsoftonline.com/chevron.onmicrosoft.com',
    redirectUri: 'https://mit-test1-dr.azure.chevron.com',
    postLogoutRedirectUri: 'http://localhost:4200/logout/'
  }
};
